import React, { useEffect, useState} from "react";
import ItemDetail from "./ItemDetail";
import { useSelector } from "react-redux";

const ItemDetailContainer = (props: any) => {
 
  const [driverIndex, setDriverIndex] = useState<any>();
 
  const [showTooltip, setShowTooltip] = useState(false);

  const onDriverClick = () => {
    setShowTooltip(!showTooltip);
  };

  const {approvalRequestOption, orderByIdValue }: any = useSelector((state: any) => ({
    approvalRequestOption: state.OrderApprovalReducer.approvalRequestOption,
    orderByIdValue: state.OrderReducer.orderByIdData
  }));

  const getRequestStyle = (index: number) => {
    const reqData = approvalRequestOption;
    if(reqData.length>0){
    const filter = reqData?.filter((item: any) => item.key === index);
    if (filter?.length) {
      return filter[0].request?.split(" ")?.slice(0, 1);
    }
  }
  };

  useEffect(() => {
    const documentClick = (e: any) => {
      if (!e?.target?.closest(".blueBadge")) {
        setDriverIndex(null);
      }
    };
    document.addEventListener("click", documentClick);
    return () => {
      document.removeEventListener("click", documentClick);
    };
  }, []);

  return (
    <ItemDetail
      requestReasonDetailData={props?.requestReasonDetailData}
      orderByIdValue={orderByIdValue}
      getRequestStyle={getRequestStyle}
      onDriverClick={onDriverClick}
      driverIndex={driverIndex}
      showTooltip={showTooltip}
      isBulkOrder={props?.isBulkOrder}
    />
  );
};
export default ItemDetailContainer;
